import axios from "../api/axios"
import { linkUrl } from "../helpers/apiUrls"
import { makeRequest } from "../helpers/makeRequest"

export default function useLinkService() {

    const getLink = (kind, token) => {
        return makeRequest(axios, `${linkUrl}${kind}/${token}/`, {
            method: "GET"
        })
    }

    const checkLink = (kind, token) => {
        return makeRequest(axios, `${linkUrl}${kind}/${token}/check/`, {
            method: "GET"
        })
    }

    
    const activateLink = (kind, token, data) => {
        return makeRequest(axios, `${linkUrl}${kind}/${token}/activate/`, {
            method: "POST",
            data: data,
        })
    }

    return {
        getLink,
        checkLink,
        activateLink
    }

}